<!--<div class="logo-main" fxLayout="row" fxLayoutAlign="center" (click)="gotoPortal()">-->
<!--</div>-->

<div class="logo-main" fxLayout="row" fxLayoutAlign="center" (click)="gotoPortal()">
</div>